import { useState, useMemo } from 'react';
import type { Service } from '@/types/service';
import serviceData from '@/data/services.json';

export function useServices() {
  const [selectedCategory, setSelectedCategory] = useState('all');

  const services: Service[] = serviceData.services;
  const categories = serviceData.categories;

  const filteredServices = useMemo(() => {
    if (selectedCategory === 'all') return services;
    return services.filter((s) => s.category === selectedCategory);
  }, [services, selectedCategory]);

  const popularServices = useMemo(
    () => services.filter((s) => s.popular),
    [services]
  );

  return {
    services: filteredServices,
    popularServices,
    categories,
    selectedCategory,
    setSelectedCategory,
  };
}
